<fin-skip-link [main]="main" />

<router-outlet name="header" />

<main #main [class.layout--footer-open]="isFooterOpen$ | async" role="main">
  <router-outlet />
</main>

<footer>
  <router-outlet name="footer" />
</footer>
